async function getCartDetails() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();

    console.log(cart); // Aqui você verá os dados do carrinho no console
    return cart; // Podemos utilizar esses dados para enviar para a Eduzz
  } catch (error) {
    console.error('Erro ao obter detalhes do carrinho:', error);
  }
}

async function sendCartToEduzz(cart) {
  try {
    // Preparar os dados do carrinho para enviar à Eduzz
    const cartData = {
      items: cart.items.map(item => ({
        id: item.id,
        title: item.title,
        quantity: item.quantity,
        price: item.price
      })),
      total_price: cart.total_price
    };

    // Enviar para a Eduzz
    const eduzzResponse = await fetch('https://api2.eduzz.com/content/content_list', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer af9df24581522e47da360473060fd12264ab5471792c72f51e6c6097d26d288e',
        'PublicKey': '5656565',
        'APIKey': 'haskjdhfkjahsdlkjfhaljskdhflkjah'
      },
      body: JSON.stringify(cartData)
    });

    const result = await eduzzResponse.json();
    console.log('Dados enviados para a Eduzz:', result);
  } catch (error) {
    console.error('Erro ao enviar os dados do carrinho para a Eduzz:', error);
  }
}

// Chama a função quando o botão de finalizar compra for clicado
document.addEventListener('DOMContentLoaded', function() {
  document.getElementById('checkout').addEventListener('click', async function(event) {
    event.preventDefault();
    const cart = await getCartDetails();
    sendCartToEduzz(cart);
  });
});
